import { LoadingOutlined } from '@ant-design/icons';
import { Row, Spin, theme } from 'antd';
import Head from 'next/head';
import { CSSProperties, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import CompanyLogoContainer from '../../src/containers/Requests/CompanyLogoContainer';
import usePublicCompanySettings from '../../src/hooks/end-user-form/usePublicCompanySettings';
import { isSSR } from '../../src/utils/helpers';

const defaultCompanyName = isSSR() ? process.env.BRAND_NAME : process.env.NEXT_PUBLIC_BRAND_NAME;

const antIcon = <LoadingOutlined style={{ fontSize: '3rem' }} spin />;

const styles = {
    root: { minHeight: '100dvh', flexDirection: 'column' } as CSSProperties
};
export default function EndUserPageUIContainer({
    children,
    isLogoHidden = false
}: PropsWithChildren<{ isLogoHidden?: boolean }>) {
    const {
        token: { colorBgLayout }
    } = theme.useToken();

    const { t } = useTranslation('seo');

    const { data: publicCompanySettings, isLoading } = usePublicCompanySettings();
    const logoSettings = publicCompanySettings?.find((setting) => setting.key === 'COMPANY_LOGO');
    const companyNameInSettings = publicCompanySettings?.find((setting) => setting.key === 'COMPANY_NAME')?.value;
    const companyName = companyNameInSettings || defaultCompanyName.toUpperCase();

    return (
        <>
            <Head>
                <title>{t('title', { companyName })}</title>
                <meta name="description" content={t('description', { companyName })} />
                {/* <meta name="keywords" content={keyword} /> */}
                <meta name="referrer" content="no-referrer-when-downgrade" />
                <meta name="og:title" content={t('title', { companyName })} />
                <meta name="og:description" content={t('description', { companyName })} />
                <meta name="og:type" content="website" />
                {/* <meta name="og:url" content={url} />
                <meta name="og:image" content={image} /> */}
            </Head>
            <Row justify="center" align="middle" style={{ ...styles.root, backgroundColor: colorBgLayout }}>
                {isLoading ? (
                    <Spin indicator={antIcon} />
                ) : (
                    <>
                        {!isLogoHidden && <CompanyLogoContainer logoSettings={logoSettings} />}
                        {children}
                    </>
                )}
            </Row>
        </>
    );
}
